import React, { createContext, useEffect, useState, useContext } from "react";

const MemberstackContext = createContext(null);

export const MemberstackProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const memberstack = window.$memberstackDom;
    if (!memberstack) return;
  
    const fetchMember = async () => {
      const { data: memberData } = await memberstack.getCurrentMember();
      setMember(memberData);
      setLoading(false);
    };
  
    fetchMember();
  
    memberstack.onAuthChange((memberData) => {
      setMember(memberData);
    });
  }, []);

  return (
    <MemberstackContext.Provider value={{ member, loading }}>
      {children}
    </MemberstackContext.Provider>
  );
};

export const useMemberstack = () => {
  const context = useContext(MemberstackContext);
  if (context === undefined) {
    throw new Error("useMemberstack doit \u00eatre utilis\u00e9 dans un MemberstackProvider");
  }
  return context;
};
